var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as formActions } from 'react-redux-form';
import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { Icon } from "../../UI";
import { withContext } from "../../componentWrappers";
import { ShowMetadata, MetadataForm, MetadataFormButtons, actions } from "../../Metadata";
import { Translate, I18NLink } from "../../I18N";
import SidePanel from "../../Layout/SidePanel";
import { CopyFromEntity } from "../../Metadata/components/CopyFromEntity";
import { api as entitiesAPI } from "../../Entities";
import { RequestParams } from "../../utils/RequestParams";
import { saveEntityWithFiles } from "../../Library/actions/saveEntityWithFiles";
import { AttachmentsList } from "../../Attachments";
import { FileList } from "../../Attachments/components/FileList";
import {
  unselectConnection,
  updateRelationshipEntityData,
  addEntity,
  setAddToData,
  reloadRelationships } from "../actions/actions";


class RelationshipMetadata extends Component {
  constructor(props) {
    super(props);
    this.state = { copyFrom: false, copyFromProps: [] };

    this.toggleCopyFrom = this.toggleCopyFrom.bind(this);
    this.onCopyFromSelect = this.onCopyFromSelect.bind(this);
    this.deleteDocument = this.deleteDocument.bind(this);
    this.saveEntity = this.saveEntity.bind(this);
    this.closeSidePanel = this.closeSidePanel.bind(this);
  }

  onCopyFromSelect(copyFromProps) {
    this.setState({ copyFromProps });
  }

  async deleteDocument() {
    this.props.mainContext.confirm({
      accept: async () => {
        this.props.unselectConnection();
        await entitiesAPI.delete(new RequestParams({ sharedId: this.props.entity.sharedId }));
        await this.props.reloadRelationships(this.props.parentSharedId);
      },
      title: 'Confirm deletion of entity',
      message: 'Are you sure you want to delete this entity?'
    });
  }

  async saveEntity(entity, formModel) {
    this.props.resetForm(formModel);
    this.props.unselectConnection();
    const { entity: savedEntity, errors } = await saveEntityWithFiles(entity);
    this.props.updateRelationshipEntityData(savedEntity);

    if (Number.isInteger(this.props.hubIndex)) {
      this.props.addEntity(
        this.props.hubIndex,
        this.props.rightRelationshipIndex,
        savedEntity,
        errors
      );
      this.props.setAddToData(null, null);
    }
  }

  toggleCopyFrom() {
    this.setState((currentState) => ({
      copyFrom: !currentState.copyFrom
    }));
  }

  closeSidePanel() {
    return this.props.entityBeingEdited ?
    this.props.resetForm('relationships.metadata') :
    this.props.unselectConnection();
  }

  renderForm() {
    const form = /*#__PURE__*/
    _jsx(MetadataForm, {
      model: "relationships.metadata",
      initialTemplateId: this.props.entity.template,
      templateId: this.props.formMetadata.template,
      onSubmit: this.saveEntity,
      changeTemplate: this.props.changeTemplate,
      highlightedProps: this.state.copyFromProps }
    );


    return this.state.copyFrom ? /*#__PURE__*/
    _jsx("div", { className: "tab-content tab-content-visible" }, void 0,
    form, /*#__PURE__*/
    _jsx(CopyFromEntity, {
      isVisible: this.state.copyFrom,
      originalEntity: this.props.formMetadata,
      templates: this.props.templates,
      onSelect: this.onCopyFromSelect,
      formModel: "relationships.metadata",
      onCancel: this.toggleCopyFrom }
    )
    ) :

    form;

  }

  renderBody() {
    return this.props.entityBeingEdited ?
    this.renderForm() : /*#__PURE__*/

    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(ShowMetadata, { entity: this.props.entity, showTitle: true, showType: true }), /*#__PURE__*/
    _jsx(FileList, { entity: this.props.entity, files: this.props.entity.documents, readonly: true }), /*#__PURE__*/
    _jsx(AttachmentsList, {
      entity: this.props.entity,
      attachments: this.props.entity.attachments,
      readOnly: true }
    )
    );

  }

  renderButtons() {
    if (this.props.entityBeingEdited) {
      return (/*#__PURE__*/
        _jsx(MetadataFormButtons, {
          data: Immutable.fromJS(this.props.entity),
          delete: this.deleteDocument,
          formStatePath: "relationships.metadata",
          formState: this.props.formState,
          entityBeingEdited: this.props.entityBeingEdited,
          copyFrom: this.toggleCopyFrom,
          hideDelete: this.props.hubsBeingEdited,
          includeViewButton: false }
        ));

    }
    return (/*#__PURE__*/
      _jsx(I18NLink, {
        to: `entity/${this.props.entity.sharedId}`,
        className: "btn btn-default",
        tabIndex: "0" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "file" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "View")
      )
      ));

  }

  render() {
    const twoColumns = this.state.copyFrom ? 'two-columns' : '';
    return (/*#__PURE__*/
      _jsx(SidePanel, {
        open: this.props.selectedConnection,
        className: `connections-metadata ${twoColumns}` }, void 0,

      !this.state.copyFrom && /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "closeSidepanel close-modal",
        onClick: this.closeSidePanel }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "times" })
      ), /*#__PURE__*/

      _jsx("div", { className: "sidepanel-body" }, void 0, this.renderBody()), /*#__PURE__*/
      _jsx("div", { className: "sidepanel-footer" }, void 0, this.renderButtons())
      ));

  }
}

RelationshipMetadata.defaultProps = {
  selectedConnection: false,
  entityBeingEdited: false,
  hubsBeingEdited: false,
  hubIndex: null,
  rightRelationshipIndex: null
};
























const connectionSelector = createSelector(
  (state) => state.relationships.connection,
  (entity) => entity && entity.toJS ? entity.toJS() : { metadata: {} }
);

const mapStateToProps = (state) => {
  const entityBeingEdited = Boolean(state.relationships.metadata.metadata);

  return {
    selectedConnection: Boolean(
      state.relationships.connection && state.relationships.connection.get('_id') ||
      entityBeingEdited
    ),
    entity: connectionSelector(state),
    entityBeingEdited,
    hubsBeingEdited: Boolean(state.relationships.hubActions.get('editing')),
    templates: state.templates,
    formMetadata: state.relationships.metadata,
    formState: state.relationships.formState,
    hubIndex: state.relationships.hubActions.getIn(['addTo', 'hubIndex']),
    rightRelationshipIndex: state.relationships.hubActions.getIn([
    'addTo',
    'rightRelationshipIndex']
    ),
    parentSharedId: state.relationships.list.sharedId
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      unselectConnection,
      updateRelationshipEntityData,
      changeTemplate: actions.changeTemplate,
      addEntity,
      setAddToData,
      resetForm: formActions.reset,
      reloadRelationships
    },
    dispatch
  );
}

export { RelationshipMetadata, mapStateToProps };

export default connect(mapStateToProps, mapDispatchToProps)(withContext(RelationshipMetadata));